'use client';

import dynamic from 'next/dynamic';

export const DepositModal = dynamic(
  () => import('./DepositModal').then((mod) => mod.DepositModal),
  { ssr: false }
);
